<!-- <ion-header>
    <ion-fab right no-margin>
        <button top right ion-button (click)="gotoSearch($event)">
          <ion-icon padding name="search"></ion-icon>
        </button>
      </ion-fab>

    <div>
        <scroll-tabsparent #scrollTab [tabs]="tabsparent" ></scroll-tabsparent>
        <scroll-tabschild #scrollTab [tabs]="tabsparent[index].subtabs" ></scroll-tabschild>

      </div>

     
  
    <div>
    <div class="scroll-tabs">
        <ion-scroll #scrollTab class="scroll-container" scrollX="true">
          <div class="section" *ngFor="let tab of tabsparent">
            <button class="tab9-button" [class.three]="tabsparent.length<=3" [class.selected]="tab.selected" ion-button small clear (click)="tabChange(tab)">
              {{tab.title}}
            </button>
          </div>
        </ion-scroll>
        <tab-page></tab-page>
      </div>
    </div> 
  </ion-header> -->

 
<ion-content [hidden]="searchEnable">
    <ion-fab right edge no-margin>
<!--           <ion-icon color="light"  name="search"></ion-icon>
 -->          <img src="assets/dnrsavings/assets/savingsimg/btn_filter_deal_search.png"  (click)="gotoSearch($event)" height="48px" width="48px">
      </ion-fab>
    <parent-custom-super-tabs #parentTab id="parent" no-padding no-margin tabsPlacement="top" scrollTabs="true" [selectedTabIndex]="_index"
    toolbarColor="light" toolbarBackground="savingstab" indicatorColor="light" badgeColor="light" (tabSelect)="onTabSelect($event)" [isSearchEnabled]="searchEnable">
        <parent-custom-super-tab  *ngFor="let tab of tabsparent" [rootParams]="tab.params" [id]="tab.id" [root]="tab.root" [title]="tab.title" ></parent-custom-super-tab>
      </parent-custom-super-tabs> 

     
</ion-content >
 <ion-content  *ngIf="searchEnable">
<search-tabs  (messageEvent)="receiveMessage($event)"></search-tabs>

</ion-content> 

